// components/PublicOnlyRoute.jsx
import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { HerracContext } from './App';

const PublicOnlyRoute = ({ children }) => {
  const { user } = useContext(HerracContext);

  return user ? <Navigate to="/" replace /> : children;
};

export default PublicOnlyRoute;
